<style >

  .router-fade-enter-active, .router-fade-leave-active {
    transition: opacity .3s;
  }
  .router-fade-enter, .router-fade-leave-active {
    opacity: 0;
  }
</style>

<template>
	<div v-wechat-title="$route.meta.title">
    <transition name="router-fade" mode="out-in">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
			</keep-alive>
    </transition>

    <transition name="router-fade" mode="out-in">
			<router-view v-if="!$route.meta.keepAlive"></router-view>
		</transition>

    <player></player>
  </div>


</template>
<script>
  import player from './components/player'
  export default {
    created() {
      var _mtac = {"performanceMonitor":1};
      (function() {
        var mta = document.createElement("script");
        mta.src = "//pingjs.qq.com/h5/stats.js?v2.0.4";
        mta.setAttribute("name", "MTAH5");
        mta.setAttribute("sid", "500693284");
        mta.setAttribute("cid", "500693305");
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(mta, s);
      })();
    },
    components: {
      player
    }
  }
</script>






// WEBPACK FOOTER //
// src/App.vue